/**
 * Directive that forces the top value for position absolute elements, so they
 * appear on the scroll position
 */
angular.module('coreModule').directive('swOpenInPlace', ($window) => {
  return {
    restrict: 'A',
    // simliar & good tests: core/test/spec/components/sw-scroll-top.js
    // getting a handler on the element your directive is on: core/test/spec/directives/sw-enter.js
    link: (scope, element) => {
      const distanceFromHeader = 20;

      element.css('top', `${$window.pageYOffset + distanceFromHeader}px`);
    },
  };
});
